<script>
export default {
    props: {
        icon: {
            type: String,
            required: true
        },
        message: {
            type: String,
            required: true,
        },
        confirmtext: {
            type: String,
            required: true
        }
    },
    computed: {
        imageUrl() {
            const regex = /src=["']([^"']+)["']/;
            const matches = this.icon.match(regex);
            return matches ? matches[1] : '';
        }
    },
    methods: {
        showCookieAlert() {

                const cookiesAccepted = localStorage.getItem('cookiesAccepted') === 'true';

                if(!cookiesAccepted) {
                        this.$swal.fire({
                        imageUrl: this.imageUrl,
                        text: this.message,
                        confirmButtonText: this.confirmtext,
                        customClass: {
                            popup:'swal-custom-popup-skyblue',
                            confirmButton: 'shadow-button'
                        },
                        allowOutsideClick: false,
                        didOpen: () => {
                            document.body.classList.remove('swal2-height-auto');
                        }
                    }).then((result) => {
                        if(result.isConfirmed) {
                            localStorage.setItem('cookiesAccepted', 'true')
                        }
                    });
                }

        }
    },
    mounted() {
        this.showCookieAlert();
    }

}
</script>
